import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getDocumentsByHash } from 'data-providers/mainAnketaProvider';

export const useDocumentsLinksPresenter = () => {
  const { otpDocLink, documents, isPEPSignature } = useSelector((state) => state.anketa || {});

  const personalDataDoc = useMemo(() => {
    return documents.find((obj) => obj.type.sysName === 'personal-data');
  }, [documents]);

  const getOtpDocHandler = async (event, hash) => {
    event.stopPropagation();
    event.preventDefault();

    await getDocumentsByHash(hash);
  };

  return {
    otpDocLink,
    isPEPSignature,
    personalDataDoc,
    getOtpDocHandler,
  };
};
